import React from 'react';
import { ArrowUpRightIcon, DatabaseIcon, ShieldCheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export const CorePrintBlock: React.FC = () => {
  return <section className="w-full bg-white pb-20 md:pb-24" data-id="element-288" data-mp="3s8yzj9pyfxwg">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-289" data-mp="3s8fu2shhr1zb">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-[#1F222C] rounded-2xl p-8 md:p-12" data-id="element-290" data-mp="11miqvszhmh2">
          <div className="flex flex-col lg:flex-row lg:items-center gap-8" data-id="element-291" data-mp="39bxu5nshnvrz">
            <div className="flex items-center justify-center w-14 h-14 rounded-xl bg-white/10 text-white flex-shrink-0" data-id="element-292" data-mp="3ea9747e2ymef">
              <DatabaseIcon className="h-7 w-7" aria-hidden="true" data-id="element-293" data-mp="17jjekvdf33eq" />
            </div>
            <div className="flex-grow max-w-2xl" data-id="element-294" data-mp="1cgi4f1q1so74">
              <p className="text-white/60 text-sm font-semibold mb-2" data-id="element-295" data-mp="3db1zyqfzvhpa">
                Voor wie verder wil groeien
              </p>
              <h2 className="text-white font-bold text-2xl md:text-3xl mb-3" data-id="element-296" data-mp="38b5wqtf4fuas">
                CorePrint, onze methodiek voor structurele groei
              </h2>
              <p className="text-white/75 leading-relaxed" data-id="element-297" data-mp="3i20g9q0zgfsj">
                Zit de basis op orde en wil je verder dan de eigen regio? Dan
                meten we eerst welke vraag er in jouw markt daadwerkelijk is,
                voordat we ergens in investeren. Een van onze zes diensten, geen
                startpunt.
              </p>
            </div>
            <a href="https://coreprint.nl/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-white text-[#1F222C] font-semibold py-3 px-6 rounded-lg hover:bg-gray-100 transition-colors duration-200 flex-shrink-0" data-id="element-298" data-mp="33ep6ntod35v2">
              Lees over CorePrint
              <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-299" data-mp="dn0qecbhax82" />
            </a>
          </div>

          {/* Marktexclusiviteit hoort uitsluitend bij het Platinum-pakket,
              niet bij CorePrint in het algemeen en niet bij losse websites. */}
          <div className="mt-8 pt-8 border-t border-white/10 flex flex-col sm:flex-row sm:items-start gap-4" data-id="element-300" data-mp="3ggq67x3jm6lu">
            <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-white/10 text-white flex-shrink-0" data-id="element-301" data-mp="3lg2ywyh3i7wc">
              <ShieldCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-302" data-mp="2oqln01rirpm7" />
            </div>
            <div data-id="element-303" data-mp="2srxholp93119">
              <h3 className="text-white font-semibold text-lg mb-2" data-id="element-304" data-mp="2srfawv4yp4f3">
                Marktexclusiviteit bij Platinum
              </h3>
              <p className="text-white/70 leading-relaxed text-sm max-w-3xl" data-id="element-305" data-mp="2xo5tbp48oc3o">
                Kies je voor het Platinum-pakket, dan werken we in jouw markt en
                regio niet ook voor je directe concurrent zolang het traject
                loopt. Bij de andere pakketten geldt die afspraak niet.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};